import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const KEY = "il_cookie_consent";

function enableAnalytics() {
  if (window.posthog) {
    window.posthog.opt_in_capturing();
    window.posthog.capture("$pageview");
  }
}

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    let choice = null;
    try {
      choice = localStorage.getItem(KEY);
    } catch {
      /* storage unavailable */
    }
    if (choice === "accepted") {
      enableAnalytics();
    } else if (!choice) {
      setShow(true);
    }
  }, []);

  const decide = (value) => {
    try {
      localStorage.setItem(KEY, value);
    } catch {
      /* storage unavailable */
    }
    if (value === "accepted") enableAnalytics();
    else if (window.posthog) window.posthog.opt_out_capturing();
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[120] px-4 pb-4 sm:px-6 sm:pb-6 pointer-events-none"
      data-testid="cookie-consent"
    >
      <div className="pointer-events-auto max-w-3xl mx-auto rounded-2xl bg-surface border border-white/10 shadow-[0_24px_60px_rgba(0,0,0,0.5)] p-5 sm:p-6 flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        <p className="text-white/75 text-[13px] leading-relaxed flex-1">
          We use privacy-friendly, cookieless analytics to understand how the site is used. Nothing runs until you agree.{" "}
          <Link to="/privacy" className="text-embersoft underline underline-offset-2 hover:text-ember transition-colors">
            Privacy policy
          </Link>
          .
        </p>
        <div className="flex items-center gap-3 shrink-0">
          <button
            type="button"
            onClick={() => decide("declined")}
            data-testid="cookie-decline"
            className="font-eyebrow text-[11px] tracking-[0.14em] text-white/70 hover:text-white px-4 py-3 rounded-[8px] border border-white/15 hover:border-white/30 transition-colors"
          >
            DECLINE
          </button>
          <button
            type="button"
            onClick={() => decide("accepted")}
            data-testid="cookie-accept"
            className="font-eyebrow text-[11px] tracking-[0.14em] text-white bg-ember px-5 py-3 rounded-[8px] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_0_26px_rgba(232,168,124,0.55)]"
          >
            ACCEPT
          </button>
        </div>
      </div>
    </div>
  );
}
